import React, {useState, useEffect} from 'react';
import MessageFileValidation from "../../MessageFileValidation";
import InfoChip from "../../InfoChip";
import Amount from "../../Amount";
import {parseCsv} from "../../../utils/csvParseUtil";
import {useTranslation} from "react-i18next";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";

const ValidationReport = ({dataValid, uploadedData, totalCardholders, totalAmountLoaded, validationErrors}) => {

    const { t } = useTranslation();

    const [data, setData] = useState(uploadedData);

    useEffect(() => {
        if(!dataValid){
            setData(validationErrors);
        }
    }, []);

    return (
        <div className="step">
            <div className="validation-report">
                {dataValid ? <MessageFileValidation valid message={t("The CSV file has been validated successfully. Click 'continue' to proceed with card creation submission.")}/> : <MessageFileValidation
                    message={t("Your file has incorrect format or missing information. See the table below for details.")}/>}

                <div className="mb-4 mt-4">
                    <InfoChip class="mr-3" value={totalCardholders} description={t("Total Cardholders")}/>
                    <InfoChip value={<Amount amount={totalAmountLoaded} currency="USD"/>}
                              description={t("Total Amount Loaded")}/>
                </div>
                <h4>{t("CSV Field Details")}</h4>
                {data.data && data.headers && (
                    <>
                        <div className="overflow-x-auto data-table small-data-table mb-4">
                            <table>
                                <thead>
                                <tr>
                                    {data.headers.map((key) => (
                                        <th key={key} className={(key === 'error_message') ? 'error-header' : ''}>
                                            {(key.charAt(0).toUpperCase() + key.slice(1)).replace(/_/g, ' ')}
                                        </th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {data.data.map((item, index) => (
                                    <tr key={index}>
                                        {data.headers.map((header, headerIndex) => (
                                            <td key={headerIndex} dangerouslySetInnerHTML={{ __html: sanitizeHtml(item[header]) }} className={(header === 'error_message') ? 'error-cell' : ''}/>
                                        ))}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ValidationReport;
